export const ProfilesTableSkeleton = ({ pageSize }: { pageSize: number }) => {
  return (
    <div className="container mx-auto p-10">
      {/* Search Input Skeleton */}
      <div className="mb-4 w-1/3">
        <div className="h-10 w-full animate-pulse rounded-md border bg-gray-200" />
      </div>

      {/* Table Skeleton */}
      <div className="relative">
        <div className="rounded-lg border bg-white">
          {/* Table Header */}
          <div className="border-b bg-gray-50 p-4">
            <div className="grid grid-cols-4 gap-4">
              <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-28 animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
            </div>
          </div>

          {/* Table Rows */}
          {Array.from({ length: pageSize }).map((_, index) => (
            <div key={index} className="border-b p-4 last:border-b-0">
              <div className="grid grid-cols-4 gap-4">
                <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-36 animate-pulse rounded bg-gray-200" />
                <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Skeleton */}
      <div className="mt-4 flex items-center justify-between">
        <div className="h-4 w-32 animate-pulse rounded bg-gray-200" />
        <div className="flex gap-2">
          <div className="h-8 w-20 animate-pulse rounded bg-gray-200" />
          <div className="h-8 w-8 animate-pulse rounded bg-gray-200" />
          <div className="h-8 w-8 animate-pulse rounded bg-gray-200" />
          <div className="h-8 w-20 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );
};
